import axios from 'axios';




export const getDistrict = params => {
  return axios.get('/epidemic/api/epidemic/district',{params : params});
};

export const getHospital = params => {
  return axios.get('/epidemic/api/epidemic/hospital',{params : params});
};












// WEBPACK FOOTER //
// ./src/api/yq/index.js